import SDKMessageBus from '../utility/message-bus';
import { Maybe } from 'maybe-not';
import { OutletInfo } from '../types/index';

export default function requestOutletInfo(
    messageBus: SDKMessageBus,
    platformCapabilities: Set<string>
) {
    if (!platformCapabilities.has('requestOutletInfo')) {
        return;
    }

    return (): Promise<OutletInfo> => {
        return messageBus
            .sendRequest<OutletInfo>('requestOutletInfo', Maybe.nothing())
            .then(response => response.value);
    };
}
